// extracted by css-extract-rspack-plugin
export default {"greeting":"AoWZva","logo":"XqMQwY","tile":"JEhTiy","checkIcon":"yw456I","tileIcon":"Kl4yTg","tileBody":"QgumU8","spacerDesktop":"yoqmm2","tileFootnote":"PBZg3i"};